import { StreetAddress1 } from './components/StreetAddress1';
import { StreetAddress2 } from './components/StreetAddress2';
import { City } from './components/City';
import { State } from './components/State';
import { ZipCode } from './components/ZipCode';
import { isMobileScreen } from '@apply/ui';

interface BillingAddressProps {
    customPaymentId: string;
}

export const BillingAddress: React.FC<BillingAddressProps> = ({ customPaymentId }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            <div
                className='pageSubHeader'
                style={{ marginTop: 30 }}
            >
                Billing Address
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <StreetAddress1
                    customPaymentId={customPaymentId}
                    required={true}
                />
                <StreetAddress2 customPaymentId={customPaymentId} />
                <div className={`customPayment-flexRowContent ${mobileScreen ? 'mobile' : ''}`}>
                    <City
                        customPaymentId={customPaymentId}
                        required={true}
                    />
                    <State
                        customPaymentId={customPaymentId}
                        required={true}
                    />
                    <ZipCode
                        customPaymentId={customPaymentId}
                        required={true}
                    />
                </div>
            </div>
        </>
    );
};
